import { createAction } from 'redux-actions';

import types from './types';

const addGlobalMessage = createAction(types.ADD_GLOBAL_MESSAGE);
const _setGlobalMessage = createAction(types.SET_GLOBAL_MESSAGE);
const setTemporaryMessage = createAction(types.SET_TEMPORARY_MESSAGE);
const eraseTemporaryMessage = createAction(types.ERASE_TEMPORARY_MESSAGE);
const eraseWithDelayTemporaryMessage = createAction(types.ERASE_WITH_DELAY_TEMPORARY_MESSAGE);
const addMessage = createAction(types.ADD_MESSAGE);
const updateMessage = createAction(types.UPDATE_MESSAGE);
const removeMessage = createAction(types.REMOVE_MESSAGE);
const removeAllMessages = createAction(types.REMOVE_ALL_MESSAGES);
const removeMessageWithDelay = createAction(types.REMOVE_MESSAGE_WITH_DELAY);
const setGlobalError = (text, type) =>
    _setGlobalMessage({
        success: false,
        error: true,
        warning: false,
        text,
        type,
    });
const setGlobalSuccess = (text, type) =>
    _setGlobalMessage({
        success: true,
        error: false,
        warning: false,
        text,
        type,
    });
const setPreferredLanguage = createAction(types.SET_PREFERRED_LANGUAGE);
const setPreferredCountry = createAction(types.SET_PREFERRED_COUNTRY);
const setLanguage = createAction(types.SET_LANGUAGE);
const updateLanguage = createAction(types.UPDATE_LANGUAGE);
const setCountry = createAction(types.SET_COUNTRY);
const setWishlistMode = createAction(types.SET_WISHLIST_MODE);
const setSubmitting = createAction(types.SET_SUBMITTING);
const changeLanguage = createAction(types.CHANGE_LANGUAGE);
const setNestedLevelData = createAction(types.SET_NESTED_LEVEL_DATA);
const setLastTimePageLoad = createAction(types.SET_LAST_TIME_PAGE_LOAD);
const setOriginAction = createAction(types.SET_ORIGIN_ACTION);

const visited = createAction(types.VISITED);
const beforeRender = createAction(types.BEFORE_RENDER);
const pageLoad = createAction(types.PAGE_LOAD);
const pageLoadEventPushed = createAction(types.PAGE_LOAD_EVENT_PUSHED);
const goBack = createAction(types.GO_BACK);
const redirect = createAction(types.REDIRECT);
const _goto = createAction(types.GOTO);
const goto = (url, reload) => _goto({ url, reload });
const redirectPageSelectors = createAction(types.REDIRECT_PAGE_SELECTORS);
const resetFormsMessages = createAction(types.RESET_FORMS_MESSAGES);
const domContentLoaded = createAction(types.DOM_CONTENT_LOADED);
const appInit = createAction(types.APP_INIT);
const setAvailableLanguages = createAction(types.SET_AVAILABLE_LANGUAGES);
const setImagePlaceholderPath = createAction(types.SET_IMAGE_PLACEHOLDER_PATH);
const setSite = createAction(types.SET_SITE);
const setBaseStore = createAction(types.SET_BASE_STORE);
const setOccBaseUri = createAction(types.SET_OCC_BASE_URI);
const setCurrencyCode = createAction(types.SET_CURRENCY_CODE);
const disableTurbolinks = createAction(types.DISABLE_TURBOLINKS);
const closeLanguageDialog = createAction(types.CLOSE_LANGUAGE_DIALOG);
const closeCountryDialog = createAction(types.CLOSE_COUNTRY_DIALOG);
const enterClicked = createAction(types.ENTER_CLICKED);
const _doFormInitialize = createAction(types.FORM_INITIALIZE);
const doFormInitialize = (storeName, action) => _doFormInitialize({ storeName, action });
const _openURL = createAction(types.OPEN_URL);
const openURL = (url, isNewTab) => _openURL({ url, isNewTab });
const setDeliveryCountry = createAction(types.SET_DELIVERY_COUNTRY);
const getStoreConfiguration = createAction(types.GET_STORE_CONFIG);
const setStoreConfiguration = createAction(types.SET_STORE_CONFIG);

const toggleFlashMessage = createAction(
    types.TOGGLE_FLASH_MESSAGE,
    (messagesGroupKey, targetMessageKey, value) => ({
        messagesGroupKey,
        targetMessageKey,
        value,
    }),
);
const setFlashMessageGroup = createAction(
    types.SET_FLASH_MESSAGE_GROUP,
    (messagesGroupKey, value) => ({ messagesGroupKey, value }),
);
const setPrevPageData = createAction(types.SET_PREV_PAGE_DATA);
const trackLoadPage = createAction(types.TRACK_LOAD_PAGE);
const setBrCatalogName = createAction(types.SET_BR_CATALOG_NAME);
const setGlobalPageInfo = createAction(types.SET_GLOBAL_PAGE_INFO);
const setThresholdPageInfo = createAction(types.SET_THRESHOLD_CONFIGURATION);

export default {
    addGlobalMessage,
    setGlobalError,
    setLanguage,
    changeLanguage,
    updateLanguage,
    setCountry,
    setPreferredLanguage,
    setPreferredCountry,
    visited,
    beforeRender,
    pageLoad,
    pageLoadEventPushed,
    goBack,
    redirect,
    goto,
    resetFormsMessages,
    domContentLoaded,
    appInit,
    setAvailableLanguages,
    setImagePlaceholderPath,
    setSite,
    setBaseStore,
    setOccBaseUri,
    setCurrencyCode,
    setWishlistMode,
    redirectPageSelectors,
    disableTurbolinks,
    closeCountryDialog,
    closeLanguageDialog,
    doFormInitialize,
    setSubmitting,
    enterClicked,
    setNestedLevelData,
    toggleFlashMessage,
    setFlashMessageGroup,
    setTemporaryMessage,
    eraseTemporaryMessage,
    eraseWithDelayTemporaryMessage,
    addMessage,
    updateMessage,
    removeMessage,
    removeAllMessages,
    removeMessageWithDelay,
    setLastTimePageLoad,
    setPrevPageData,
    setOriginAction,
    trackLoadPage,
    openURL,
    setDeliveryCountry,
    getStoreConfiguration,
    setStoreConfiguration,
    setBrCatalogName,
    setGlobalSuccess,
    setGlobalPageInfo,
    setThresholdPageInfo,
};
